import { ModulesActionsFactory } from "../Common/_stores/ModulesStore/ModulesActionsFactory";
import { PMSModules } from "./PMSModules";
import { PMSStore } from "./PMSStore";
import { Selectors } from "../Everou/_reducers/app.reducer";

export const genericModulesActions = ModulesActionsFactory({
    defaultAppModule: PMSModules.DEFAULT_MODULE,
});

export const PMSModulesActions = {
    selectModule: genericModulesActions.selectModule,
    setUpModules,
    refreshEnabledModules,
    _setUpModules: genericModulesActions.setUpModules,
};

function getEnabledModuleIds(getState) {
    const highestPlan =
        PMSStore.selectors.getPMSUser(getState())?.highestPlan ?? 0;
    // Only once the list has actually loaded: a failed load must not be
    // taken for "no organizations" and hide Organizations from a member.
    const hasOrganizations =
        PMSStore.selectors.getOrganizationsHasLoaded(getState()) &&
        (PMSStore.selectors.getOrganizations(getState()) ?? []).length > 0;
    return PMSModules.getEnabledModuleIds(highestPlan, hasOrganizations);
}

// Recomputes the sidebar when what gates it changes after start-up (the
// organizations landing), keeping the module on screen -- unlike
// setUpModules, which would jump back to the initial URL's module.
function refreshEnabledModules() {
    return (dispatch, getState) => {
        dispatch(PMSModulesActions._setUpModules(
            getEnabledModuleIds(getState),
            Selectors.getSelectedModuleId(getState()),
        ));
    };
}

function setUpModules() {
    return (dispatch, getState) => {
        dispatch(PMSModulesActions._setUpModules(
            getEnabledModuleIds(getState),
            PMSModules.getModuleIdForUrl(
                PMSStore.selectors.getInitialUrl(getState())
            ),
        ));
    }
}